module.exports = __webpack_public_path__ + "media/images/pen_peru-a13e2b91.png";